import { Anchor } from 'antd'
import React from 'react'
import { useUser } from 'src/context/UserContext'
import './style.css'

interface Props { items }

export const AnchorWrapper: React.FC<Props> = ({ items }) => {

    const { blackTheme } = useUser()

    return <Anchor
        className="anchor"
        style={{
            backgroundColor: blackTheme ? '#141414' : '#ffffff',
            borderColor: blackTheme ? '#303030' : '#f0f0f0'
        }}
        items={items}
    />
}

export default AnchorWrapper


// WEBPACK FOOTER //
// ./src/component/app/anchor/AnchorWrapper.tsx